module.exports = __webpack_public_path__ + "static/media/Encil_02.ea4d1f7b.pdf";